import { useState } from "react";
import PageHeader from "@/components/base/PageHeader";
import Tabs from "@/components/base/Tabs";
import { LoadingState, ErrorState } from "@/components/base/StateViews";
import { useAsync } from "@/hooks/useAsync";
import { useAuth } from "@/contexts/AuthContext";
import { listPermissionModules, listRoles, listUsers } from "@/services/userApi";
import UsersPanel from "./components/UsersPanel";
import RolesPanel from "./components/RolesPanel";
import { plural } from "@/utils/format";

async function load() {
  const [users, roles, modules] = await Promise.all([listUsers(), listRoles(), listPermissionModules()]);
  return { users, roles, modules };
}

export default function UsersPage() {
  const { data, loading, error, reload } = useAsync(load, []);
  const { refresh } = useAuth();
  const [tab, setTab] = useState("users");

  const handleChanged = async () => {
    await reload();
    await refresh();
  };

  // Écran de chargement au premier chargement seulement : un rechargement garde le panneau (et la
  // fenêtre du mot de passe provisoire qui vient de s'ouvrir).
  if (loading && !data) return <LoadingState label="Chargement des utilisateurs et rôles..." />;
  if (error || !data) return <ErrorState message={error ?? "Données indisponibles."} onRetry={reload} />;

  const { users, roles, modules } = data;

  return (
    <div className="animate-fade-in">
      <PageHeader
        title="Utilisateurs & Rôles"
        subtitle={`${plural(users.length, "utilisateur")} • ${plural(roles.length, "rôle")} • cloisonnement par cycle`}
        icon="ri-group-line"
        actions={
          <Tabs
            tabs={[
              { id: "users", label: "Utilisateurs", icon: "ri-group-line", count: users.length },
              { id: "roles", label: "Rôles & Permissions", icon: "ri-shield-keyhole-line", count: roles.length },
            ]}
            active={tab}
            onChange={setTab}
          />
        }
      />

      {tab === "users" ? (
        <UsersPanel users={users} roles={roles} onChanged={handleChanged} />
      ) : (
        <RolesPanel roles={roles} users={users} modules={modules} onChanged={handleChanged} />
      )}
    </div>
  );
}